var map = {
	"./af/analysis.json": [
		4457,
		4457
	],
	"./af/auth.json": [
		90097,
		90097
	],
	"./af/common.json": [
		95626,
		95626
	],
	"./af/emailActivation.json": [
		41991,
		41991
	],
	"./af/gameReview.json": [
		72237,
		72237
	],
	"./af/home.json": [
		76012,
		76012
	],
	"./af/lobby.json": [
		29283,
		29283
	],
	"./af/puzzles.json": [
		73750,
		73750
	],
	"./ar/analysis.json": [
		94277,
		94277
	],
	"./ar/auth.json": [
		53597,
		53597
	],
	"./ar/common.json": [
		62382,
		62382
	],
	"./ar/emailActivation.json": [
		7403,
		7403
	],
	"./ar/gameReview.json": [
		22513,
		22513
	],
	"./ar/home.json": [
		26672,
		26672
	],
	"./ar/lobby.json": [
		58071,
		58071
	],
	"./ar/puzzles.json": [
		38802,
		38802
	],
	"./az/analysis.json": [
		90781,
		90781
	],
	"./az/auth.json": [
		10437,
		10437
	],
	"./az/common.json": [
		90070,
		90070
	],
	"./az/emailActivation.json": [
		22627,
		22627
	],
	"./az/gameReview.json": [
		22089,
		22089
	],
	"./az/home.json": [
		44824,
		44824
	],
	"./az/lobby.json": [
		5711,
		5711
	],
	"./az/puzzles.json": [
		23146,
		23146
	],
	"./be/analysis.json": [
		92479,
		92479
	],
	"./be/auth.json": [
		1259,
		1259
	],
	"./be/common.json": [
		69500,
		69500
	],
	"./be/emailActivation.json": [
		7557,
		7557
	],
	"./be/gameReview.json": [
		53375,
		53375
	],
	"./be/home.json": [
		51818,
		51818
	],
	"./be/lobby.json": [
		17989,
		17989
	],
	"./be/puzzles.json": [
		25536,
		25536
	],
	"./bg/analysis.json": [
		85873,
		85873
	],
	"./bg/auth.json": [
		17417,
		17417
	],
	"./bg/common.json": [
		88770,
		88770
	],
	"./bg/emailActivation.json": [
		91407,
		91407
	],
	"./bg/gameReview.json": [
		75157,
		75157
	],
	"./bg/home.json": [
		88292,
		88292
	],
	"./bg/lobby.json": [
		38923,
		38923
	],
	"./bg/puzzles.json": [
		48606,
		48606
	],
	"./bn/analysis.json": [
		59996,
		59996
	],
	"./bn/auth.json": [
		40740,
		40740
	],
	"./bn/common.json": [
		80923,
		80923
	],
	"./bn/emailActivation.json": [
		66840,
		66840
	],
	"./bn/gameReview.json": [
		98228,
		98228
	],
	"./bn/home.json": [
		31553,
		31553
	],
	"./bn/lobby.json": [
		1616,
		1616
	],
	"./bn/puzzles.json": [
		82241,
		82241
	],
	"./bs/analysis.json": [
		42861,
		42861
	],
	"./bs/auth.json": [
		58677,
		58677
	],
	"./bs/common.json": [
		69510,
		69510
	],
	"./bs/emailActivation.json": [
		50643,
		50643
	],
	"./bs/gameReview.json": [
		28217,
		28217
	],
	"./bs/home.json": [
		65320,
		65320
	],
	"./bs/lobby.json": [
		83071,
		83071
	],
	"./bs/puzzles.json": [
		91674,
		91674
	],
	"./cs/analysis.json": [
		40014,
		40014
	],
	"./cs/auth.json": [
		20042,
		20042
	],
	"./cs/common.json": [
		5969,
		5969
	],
	"./cs/emailActivation.json": [
		67466,
		67466
	],
	"./cs/gameReview.json": [
		82002,
		82002
	],
	"./cs/home.json": [
		33139,
		33139
	],
	"./cs/lobby.json": [
		50662,
		50662
	],
	"./cs/puzzles.json": [
		59575,
		59575
	],
	"./da/analysis.json": [
		47925,
		47925
	],
	"./da/auth.json": [
		39501,
		39501
	],
	"./da/common.json": [
		3326,
		3326
	],
	"./da/emailActivation.json": [
		2651,
		2651
	],
	"./da/gameReview.json": [
		87841,
		87841
	],
	"./da/home.json": [
		29088,
		29088
	],
	"./da/lobby.json": [
		50151,
		50151
	],
	"./da/puzzles.json": [
		37186,
		37186
	],
	"./de/analysis.json": [
		92905,
		92905
	],
	"./de/auth.json": [
		43217,
		43217
	],
	"./de/common.json": [
		54698,
		54698
	],
	"./de/emailActivation.json": [
		21543,
		21543
	],
	"./de/gameReview.json": [
		72781,
		72781
	],
	"./de/home.json": [
		28460,
		28460
	],
	"./de/lobby.json": [
		71971,
		71971
	],
	"./de/puzzles.json": [
		38422,
		38422
	],
	"./el/analysis.json": [
		15123,
		15123
	],
	"./el/auth.json": [
		32799,
		32799
	],
	"./el/common.json": [
		45256,
		45256
	],
	"./el/emailActivation.json": [
		99665,
		99665
	],
	"./el/gameReview.json": [
		41003,
		41003
	],
	"./el/home.json": [
		66294,
		66294
	],
	"./el/lobby.json": [
		39873,
		39873
	],
	"./el/puzzles.json": [
		33524,
		33524
	],
	"./en-GB/analysis.json": [
		19069,
		19069
	],
	"./en-GB/auth.json": [
		6757,
		6757
	],
	"./en-GB/common.json": [
		36534,
		36534
	],
	"./en-GB/emailActivation.json": [
		7587,
		7587
	],
	"./en-GB/gameReview-ui.json": [
		64396,
		64396
	],
	"./en-GB/gameReview.json": [
		4521,
		4521
	],
	"./en-GB/home.json": [
		68216,
		68216
	],
	"./en-GB/lobby.json": [
		78095,
		78095
	],
	"./en-GB/puzzles.json": [
		65546,
		65546
	],
	"./en/analysis.json": [
		26773,
		26773
	],
	"./en/auth.json": [
		32621,
		32621
	],
	"./en/common.json": [
		28062,
		28062
	],
	"./en/emailActivation.json": [
		89211,
		89211
	],
	"./en/gameReview-ui.json": [
		6516,
		6516
	],
	"./en/gameReview.json": [
		70913,
		70913
	],
	"./en/home.json": [
		57728,
		57728
	],
	"./en/lobby.json": [
		77447,
		77447
	],
	"./en/puzzles.json": [
		15426,
		15426
	],
	"./es/analysis.json": [
		45959,
		68340
	],
	"./es/auth.json": [
		64428,
		64428
	],
	"./es/common.json": [
		94595,
		94595
	],
	"./es/emailActivation.json": [
		83120,
		83120
	],
	"./es/gameReview.json": [
		29004,
		29004
	],
	"./es/home.json": [
		75945,
		75945
	],
	"./es/lobby.json": [
		23176,
		23176
	],
	"./es/puzzles.json": [
		89113,
		89113
	],
	"./et/analysis.json": [
		54651,
		54651
	],
	"./et/auth.json": [
		76375,
		76375
	],
	"./et/common.json": [
		27136,
		27136
	],
	"./et/emailActivation.json": [
		94393,
		94393
	],
	"./et/gameReview.json": [
		79219,
		79219
	],
	"./et/home.json": [
		62126,
		62126
	],
	"./et/lobby.json": [
		58025,
		58025
	],
	"./et/puzzles.json": [
		42204,
		19823
	],
	"./fa/analysis.json": [
		91191,
		91191
	],
	"./fa/auth.json": [
		35155,
		35155
	],
	"./fa/common.json": [
		85988,
		85988
	],
	"./fa/emailActivation.json": [
		46813,
		46813
	],
	"./fa/gameReview.json": [
		58711,
		58711
	],
	"./fa/home.json": [
		2834,
		2834
	],
	"./fa/lobby.json": [
		14877,
		14877
	],
	"./fa/puzzles.json": [
		75736,
		75736
	],
	"./fi/analysis.json": [
		66063,
		66063
	],
	"./fi/auth.json": [
		33339,
		33339
	],
	"./fi/common.json": [
		76364,
		76364
	],
	"./fi/emailActivation.json": [
		78005,
		78005
	],
	"./fi/gameReview.json": [
		25007,
		25007
	],
	"./fi/home.json": [
		13754,
		13754
	],
	"./fi/lobby.json": [
		38325,
		38325
	],
	"./fi/puzzles.json": [
		79856,
		79856
	],
	"./fr/analysis.json": [
		61404,
		61404
	],
	"./fr/auth.json": [
		99908,
		99908
	],
	"./fr/common.json": [
		23547,
		23547
	],
	"./fr/emailActivation.json": [
		76120,
		76120
	],
	"./fr/gameReview.json": [
		52788,
		52788
	],
	"./fr/home.json": [
		67873,
		67873
	],
	"./fr/lobby.json": [
		46288,
		46288
	],
	"./fr/puzzles.json": [
		90497,
		90497
	],
	"./he/analysis.json": [
		16045,
		16045
	],
	"./he/auth.json": [
		96277,
		96277
	],
	"./he/common.json": [
		39654,
		39654
	],
	"./he/emailActivation.json": [
		70419,
		70419
	],
	"./he/gameReview.json": [
		72857,
		72857
	],
	"./he/home.json": [
		54440,
		54440
	],
	"./he/lobby.json": [
		84543,
		84543
	],
	"./he/puzzles.json": [
		4506,
		4506
	],
	"./hi/analysis.json": [
		93737,
		93737
	],
	"./hi/auth.json": [
		7953,
		7953
	],
	"./hi/common.json": [
		44938,
		44938
	],
	"./hi/emailActivation.json": [
		64231,
		64231
	],
	"./hi/gameReview.json": [
		82925,
		82925
	],
	"./hi/home.json": [
		96844,
		96844
	],
	"./hi/lobby.json": [
		63011,
		63011
	],
	"./hi/puzzles.json": [
		60886,
		60886
	],
	"./hr/analysis.json": [
		82978,
		82978
	],
	"./hr/auth.json": [
		43966,
		43966
	],
	"./hr/common.json": [
		12829,
		12829
	],
	"./hr/emailActivation.json": [
		83366,
		83366
	],
	"./hr/gameReview.json": [
		44286,
		44286
	],
	"./hr/home.json": [
		60767,
		60767
	],
	"./hr/lobby.json": [
		33842,
		33842
	],
	"./hr/puzzles.json": [
		71083,
		71083
	],
	"./hu/analysis.json": [
		27101,
		27101
	],
	"./hu/auth.json": [
		83461,
		83461
	],
	"./hu/common.json": [
		62742,
		62742
	],
	"./hu/emailActivation.json": [
		57987,
		57987
	],
	"./hu/gameReview.json": [
		56969,
		56969
	],
	"./hu/home.json": [
		22232,
		22232
	],
	"./hu/lobby.json": [
		31471,
		31471
	],
	"./hu/puzzles.json": [
		4714,
		4714
	],
	"./hy/analysis.json": [
		62745,
		62745
	],
	"./hy/auth.json": [
		79713,
		79713
	],
	"./hy/common.json": [
		74266,
		74266
	],
	"./hy/emailActivation.json": [
		14519,
		14519
	],
	"./hy/gameReview.json": [
		541,
		541
	],
	"./hy/home.json": [
		53180,
		53180
	],
	"./hy/lobby.json": [
		58259,
		58259
	],
	"./hy/puzzles.json": [
		25126,
		25126
	],
	"./id/analysis.json": [
		68415,
		68415
	],
	"./id/auth.json": [
		7819,
		7819
	],
	"./id/common.json": [
		24956,
		24956
	],
	"./id/emailActivation.json": [
		23845,
		23845
	],
	"./id/gameReview.json": [
		41503,
		41503
	],
	"./id/home.json": [
		88074,
		88074
	],
	"./id/lobby.json": [
		14309,
		14309
	],
	"./id/puzzles.json": [
		98336,
		98336
	],
	"./is/analysis.json": [
		24080,
		24080
	],
	"./is/auth.json": [
		43272,
		43272
	],
	"./is/common.json": [
		9255,
		9255
	],
	"./is/emailActivation.json": [
		59748,
		59748
	],
	"./is/gameReview.json": [
		53696,
		53696
	],
	"./is/home.json": [
		68413,
		68413
	],
	"./is/lobby.json": [
		57356,
		57356
	],
	"./is/puzzles.json": [
		99253,
		99253
	],
	"./it/analysis.json": [
		13743,
		13743
	],
	"./it/auth.json": [
		26619,
		26619
	],
	"./it/common.json": [
		9868,
		9868
	],
	"./it/emailActivation.json": [
		83317,
		83317
	],
	"./it/gameReview.json": [
		60015,
		60015
	],
	"./it/home.json": [
		15162,
		15162
	],
	"./it/lobby.json": [
		47669,
		47669
	],
	"./it/puzzles.json": [
		84496,
		84496
	],
	"./ja/analysis.json": [
		58019,
		58019
	],
	"./ja/auth.json": [
		90063,
		90063
	],
	"./ja/common.json": [
		87320,
		87320
	],
	"./ja/emailActivation.json": [
		83265,
		83265
	],
	"./ja/gameReview.json": [
		82267,
		82267
	],
	"./ja/home.json": [
		38822,
		38822
	],
	"./ja/lobby.json": [
		90577,
		90577
	],
	"./ja/puzzles.json": [
		36772,
		36772
	],
	"./ka/analysis.json": [
		2360,
		2360
	],
	"./ka/auth.json": [
		41760,
		41760
	],
	"./ka/common.json": [
		19775,
		19775
	],
	"./ka/emailActivation.json": [
		10796,
		10796
	],
	"./ka/gameReview.json": [
		34216,
		34216
	],
	"./ka/home.json": [
		9461,
		9461
	],
	"./ka/lobby.json": [
		31028,
		31028
	],
	"./ka/puzzles.json": [
		68541,
		68541
	],
	"./kk/analysis.json": [
		97438,
		97438
	],
	"./kk/auth.json": [
		57850,
		57850
	],
	"./kk/common.json": [
		64545,
		64545
	],
	"./kk/emailActivation.json": [
		53914,
		31533
	],
	"./kk/gameReview.json": [
		7138,
		7138
	],
	"./kk/home.json": [
		82115,
		82115
	],
	"./kk/lobby.json": [
		19382,
		19382
	],
	"./kk/puzzles.json": [
		19655,
		19655
	],
	"./ko/analysis.json": [
		71090,
		71090
	],
	"./ko/auth.json": [
		93582,
		93582
	],
	"./ko/common.json": [
		9325,
		9325
	],
	"./ko/emailActivation.json": [
		13430,
		13430
	],
	"./ko/gameReview.json": [
		36206,
		36206
	],
	"./ko/home.json": [
		94511,
		94511
	],
	"./ko/lobby.json": [
		98434,
		98434
	],
	"./ko/puzzles.json": [
		41275,
		41275
	],
	"./lt/analysis.json": [
		50820,
		50820
	],
	"./lt/auth.json": [
		21308,
		21308
	],
	"./lt/common.json": [
		2803,
		2803
	],
	"./lt/emailActivation.json": [
		14400,
		14400
	],
	"./lt/gameReview.json": [
		13436,
		13436
	],
	"./lt/home.json": [
		11609,
		11609
	],
	"./lt/lobby.json": [
		73912,
		73912
	],
	"./lt/puzzles.json": [
		16457,
		16457
	],
	"./lv/analysis.json": [
		55858,
		55858
	],
	"./lv/auth.json": [
		27534,
		27534
	],
	"./lv/common.json": [
		32013,
		32013
	],
	"./lv/emailActivation.json": [
		20598,
		20598
	],
	"./lv/gameReview.json": [
		13102,
		13102
	],
	"./lv/home.json": [
		96444,
		96444
	],
	"./lv/lobby.json": [
		34754,
		34754
	],
	"./lv/puzzles.json": [
		39995,
		39995
	],
	"./ml/analysis.json": [
		88331,
		88331
	],
	"./ml/auth.json": [
		57927,
		57927
	],
	"./ml/common.json": [
		45648,
		45648
	],
	"./ml/emailActivation.json": [
		36937,
		36937
	],
	"./ml/gameReview.json": [
		29219,
		29219
	],
	"./ml/home.json": [
		10974,
		10974
	],
	"./ml/lobby.json": [
		96569,
		96569
	],
	"./ml/puzzles.json": [
		96428,
		96428
	],
	"./mn/analysis.json": [
		83181,
		83181
	],
	"./mn/auth.json": [
		60149,
		60149
	],
	"./mn/common.json": [
		1126,
		1126
	],
	"./mn/emailActivation.json": [
		75955,
		75955
	],
	"./mn/gameReview.json": [
		53081,
		53081
	],
	"./mn/home.json": [
		90056,
		90056
	],
	"./mn/lobby.json": [
		21759,
		21759
	],
	"./mn/puzzles.json": [
		18106,
		18106
	],
	"./nb/analysis.json": [
		56884,
		56884
	],
	"./nb/auth.json": [
		21900,
		21900
	],
	"./nb/common.json": [
		56483,
		56483
	],
	"./nb/emailActivation.json": [
		14416,
		14416
	],
	"./nb/gameReview.json": [
		82124,
		82124
	],
	"./nb/home.json": [
		40777,
		40777
	],
	"./nb/lobby.json": [
		60968,
		60968
	],
	"./nb/puzzles.json": [
		75417,
		75417
	],
	"./nl/analysis.json": [
		86070,
		86070
	],
	"./nl/auth.json": [
		52322,
		52322
	],
	"./nl/common.json": [
		92617,
		92617
	],
	"./nl/emailActivation.json": [
		26162,
		26162
	],
	"./nl/gameReview.json": [
		64826,
		64826
	],
	"./nl/home.json": [
		10251,
		10251
	],
	"./nl/lobby.json": [
		35150,
		35150
	],
	"./nl/puzzles.json": [
		11807,
		11807
	],
	"./pl/analysis.json": [
		42499,
		64880
	],
	"./pl/auth.json": [
		20520,
		20520
	],
	"./pl/common.json": [
		24007,
		24007
	],
	"./pl/emailActivation.json": [
		38660,
		38660
	],
	"./pl/gameReview.json": [
		84832,
		84832
	],
	"./pl/home.json": [
		27165,
		27165
	],
	"./pl/lobby.json": [
		88524,
		88524
	],
	"./pl/puzzles.json": [
		91925,
		91925
	],
	"./ps/analysis.json": [
		22695,
		22695
	],
	"./ps/auth.json": [
		95331,
		95331
	],
	"./ps/common.json": [
		54484,
		54484
	],
	"./ps/emailActivation.json": [
		28621,
		28621
	],
	"./ps/gameReview.json": [
		42375,
		42375
	],
	"./ps/home.json": [
		29378,
		29378
	],
	"./ps/lobby.json": [
		83309,
		83309
	],
	"./ps/puzzles.json": [
		70184,
		70184
	],
	"./pt-PT/analysis.json": [
		30857,
		30857
	],
	"./pt-PT/auth.json": [
		50769,
		50769
	],
	"./pt-PT/common.json": [
		28650,
		28650
	],
	"./pt-PT/emailActivation.json": [
		70695,
		70695
	],
	"./pt-PT/gameReview.json": [
		10317,
		10317
	],
	"./pt-PT/home.json": [
		52364,
		52364
	],
	"./pt-PT/lobby.json": [
		75747,
		75747
	],
	"./pt-PT/puzzles.json": [
		30326,
		30326
	],
	"./pt/analysis.json": [
		94600,
		94600
	],
	"./pt/auth.json": [
		68336,
		68336
	],
	"./pt/common.json": [
		34959,
		34959
	],
	"./pt/emailActivation.json": [
		83388,
		83388
	],
	"./pt/gameReview.json": [
		91256,
		91256
	],
	"./pt/home.json": [
		91621,
		91621
	],
	"./pt/lobby.json": [
		8516,
		8516
	],
	"./pt/puzzles.json": [
		49485,
		49485
	],
	"./ro/analysis.json": [
		71113,
		71113
	],
	"./ro/auth.json": [
		2385,
		2385
	],
	"./ro/common.json": [
		6314,
		6314
	],
	"./ro/emailActivation.json": [
		15847,
		15847
	],
	"./ro/gameReview.json": [
		36621,
		36621
	],
	"./ro/home.json": [
		3980,
		3980
	],
	"./ro/lobby.json": [
		37987,
		37987
	],
	"./ro/puzzles.json": [
		67926,
		67926
	],
	"./ru/analysis.json": [
		80767,
		80767
	],
	"./ru/auth.json": [
		1291,
		1291
	],
	"./ru/common.json": [
		77980,
		77980
	],
	"./ru/emailActivation.json": [
		64421,
		64421
	],
	"./ru/gameReview.json": [
		49215,
		49215
	],
	"./ru/home.json": [
		47754,
		47754
	],
	"./ru/lobby.json": [
		49349,
		49349
	],
	"./ru/puzzles.json": [
		90624,
		90624
	],
	"./sk/analysis.json": [
		89782,
		89782
	],
	"./sk/auth.json": [
		37570,
		37570
	],
	"./sk/common.json": [
		52809,
		52809
	],
	"./sk/emailActivation.json": [
		95154,
		95154
	],
	"./sk/gameReview.json": [
		52730,
		52730
	],
	"./sk/home.json": [
		17259,
		17259
	],
	"./sk/lobby.json": [
		57518,
		57518
	],
	"./sk/puzzles.json": [
		45087,
		45087
	],
	"./sl/analysis.json": [
		82905,
		82905
	],
	"./sl/auth.json": [
		15041,
		15041
	],
	"./sl/common.json": [
		31533,
		53914
	],
	"./sl/emailActivation.json": [
		80215,
		80215
	],
	"./sl/gameReview.json": [
		5917,
		5917
	],
	"./sl/home.json": [
		38460,
		38460
	],
	"./sl/lobby.json": [
		93811,
		93811
	],
	"./sl/puzzles.json": [
		86534,
		86534
	],
	"./sr/analysis.json": [
		4427,
		4427
	],
	"./sr/auth.json": [
		5799,
		5799
	],
	"./sr/common.json": [
		9168,
		9168
	],
	"./sr/emailActivation.json": [
		71497,
		71497
	],
	"./sr/gameReview.json": [
		67811,
		67811
	],
	"./sr/home.json": [
		58846,
		58846
	],
	"./sr/lobby.json": [
		65753,
		65753
	],
	"./sr/puzzles.json": [
		10732,
		10732
	],
	"./sv/analysis.json": [
		4879,
		4879
	],
	"./sv/auth.json": [
		82875,
		82875
	],
	"./sv/common.json": [
		51148,
		51148
	],
	"./sv/emailActivation.json": [
		87733,
		87733
	],
	"./sv/gameReview-final.json": [
		48762,
		48762
	],
	"./sv/gameReview.json": [
		29775,
		29775
	],
	"./sv/home.json": [
		24922,
		24922
	],
	"./sv/lobby.json": [
		88725,
		88725
	],
	"./sv/puzzles.json": [
		57552,
		57552
	],
	"./sw/analysis.json": [
		50258,
		50258
	],
	"./sw/auth.json": [
		17070,
		17070
	],
	"./sw/common.json": [
		42637,
		42637
	],
	"./sw/emailActivation.json": [
		25878,
		25878
	],
	"./sw/gameReview.json": [
		25102,
		25102
	],
	"./sw/home.json": [
		47343,
		47343
	],
	"./sw/lobby.json": [
		58754,
		58754
	],
	"./sw/puzzles.json": [
		22683,
		22683
	],
	"./th/analysis.json": [
		14240,
		14240
	],
	"./th/auth.json": [
		52024,
		52024
	],
	"./th/common.json": [
		12535,
		12535
	],
	"./th/emailActivation.json": [
		46772,
		46772
	],
	"./th/gameReview.json": [
		78896,
		78896
	],
	"./th/home.json": [
		39149,
		39149
	],
	"./th/lobby.json": [
		90780,
		90780
	],
	"./th/puzzles.json": [
		97029,
		97029
	],
	"./tk/analysis.json": [
		68795,
		68795
	],
	"./tk/auth.json": [
		43607,
		43607
	],
	"./tk/common.json": [
		82080,
		82080
	],
	"./tk/emailActivation.json": [
		41318,
		18937
	],
	"./tk/gameReview.json": [
		84307,
		84307
	],
	"./tk/home.json": [
		78062,
		78062
	],
	"./tk/lobby.json": [
		77129,
		77129
	],
	"./tk/puzzles.json": [
		19823,
		42204
	],
	"./tr/analysis.json": [
		28614,
		28614
	],
	"./tr/auth.json": [
		31698,
		31698
	],
	"./tr/common.json": [
		49945,
		49945
	],
	"./tr/emailActivation.json": [
		19298,
		19298
	],
	"./tr/gameReview.json": [
		99530,
		99530
	],
	"./tr/home.json": [
		44571,
		44571
	],
	"./tr/lobby.json": [
		53918,
		53918
	],
	"./tr/puzzles.json": [
		14991,
		14991
	],
	"./uk/analysis.json": [
		19695,
		42076
	],
	"./uk/auth.json": [
		69188,
		69188
	],
	"./uk/common.json": [
		62875,
		62875
	],
	"./uk/emailActivation.json": [
		7832,
		7832
	],
	"./uk/gameReview.json": [
		56948,
		56948
	],
	"./uk/home.json": [
		37153,
		37153
	],
	"./uk/lobby.json": [
		56656,
		56656
	],
	"./uk/puzzles.json": [
		3201,
		3201
	],
	"./uz/analysis.json": [
		82409,
		82409
	],
	"./uz/auth.json": [
		13489,
		13489
	],
	"./uz/common.json": [
		27114,
		27114
	],
	"./uz/emailActivation.json": [
		70855,
		70855
	],
	"./uz/gameReview.json": [
		74669,
		74669
	],
	"./uz/home.json": [
		99404,
		99404
	],
	"./uz/lobby.json": [
		64483,
		64483
	],
	"./uz/puzzles.json": [
		1206,
		1206
	],
	"./vi/analysis.json": [
		70431,
		70431
	],
	"./vi/auth.json": [
		8299,
		8299
	],
	"./vi/common.json": [
		84636,
		84636
	],
	"./vi/emailActivation.json": [
		52773,
		52773
	],
	"./vi/gameReview.json": [
		55807,
		55807
	],
	"./vi/home.json": [
		75210,
		75210
	],
	"./vi/lobby.json": [
		53189,
		53189
	],
	"./vi/puzzles.json": [
		52992,
		52992
	],
	"./zh-CN/analysis.json": [
		23496,
		23496
	],
	"./zh-CN/auth.json": [
		78096,
		78096
	],
	"./zh-CN/common.json": [
		40655,
		40655
	],
	"./zh-CN/emailActivation.json": [
		5052,
		5052
	],
	"./zh-CN/gameReview.json": [
		16376,
		16376
	],
	"./zh-CN/home.json": [
		89061,
		89061
	],
	"./zh-CN/lobby.json": [
		7716,
		7716
	],
	"./zh-CN/puzzles.json": [
		31661,
		31661
	],
	"./zh-TW/analysis.json": [
		83956,
		83956
	],
	"./zh-TW/auth.json": [
		12236,
		12236
	],
	"./zh-TW/common.json": [
		83651,
		83651
	],
	"./zh-TW/emailActivation.json": [
		27280,
		27280
	],
	"./zh-TW/gameReview.json": [
		95135,
		17516
	],
	"./zh-TW/home.json": [
		53238,
		53238
	],
	"./zh-TW/lobby.json": [
		48552,
		48552
	],
	"./zh-TW/puzzles.json": [
		313,
		313
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4211;
module.exports = webpackAsyncContext;